import officeSkillInfoReducer from "./reducers";
export { default as officeSkillInfoTypes } from "./types";
export { default as officeSkillInfoOperations } from "./operations";
export default officeSkillInfoReducer;
